export default "__VITE_ASSET__0cf6f76a__"